<div class="ml-2 flex h-16 flex-row space-x-5">
  <div
    tp="Turn off formula to activate control"
    [tpIsEnabled]="isDisabled === true"
  >
    <ng-select
      #fractionDayOfWeekTypeSelect
      [fixNgSelectBottom]="fractionDayOfWeekTypeSelect"
      data-cy="fractionDayOfWeekTypeSelect"
      class="fraction-type-select w-48"
      [items]="fractionDayOfWeekTypesList"
      [clearable]="false"
      [searchable]="false"
      [disabled]="isDisabled === true"
      [(ngModel)]="fraction.type"
      (change)="typeChange($event)"
      (keyup.esc)="
        $event.stopImmediatePropagation(); fractionDayOfWeekTypeSelect.blur()
      "
      (keyup.enter)="
        $event.stopImmediatePropagation(); fractionDayOfWeekTypeSelect.blur()
      "
      appendTo="body"
      bindLabel="label"
      bindValue="value"
    >
      <ng-template ng-label-tmp let-item="item">
        <div class="ml-1 truncate">{{ item.label }}</div>
      </ng-template>

      <ng-template ng-option-tmp let-item="item">
        <div
          class="flex flex-row"
          [ngClass]="{
            'text-yellow-700': item.operator === fractionOperatorEnum.And
          }"
        >
          <div class="ml-1">{{ item.operator | uppercase }} -</div>
          <div class="ml-1 truncate">{{ item.label }}</div>
        </div>
      </ng-template>
    </ng-select>
  </div>

  <div
    *ngIf="
      fraction.type === fractionTypeEnum.DayOfWeekIs ||
      fraction.type === fractionTypeEnum.DayOfWeekIsNot
    "
    tp="Turn off formula to activate control"
    [tpIsEnabled]="isDisabled === true"
  >
    <ng-select
      #fractionDayOfWeekValueSelect
      [fixNgSelectBottom]="fractionDayOfWeekValueSelect"
      data-cy="fractionDayOfWeekValueSelect"
      class="popup-55 w-48"
      [ngClass]="{
        'cursor-default': isDisabled === true
      }"
      [items]="fractionDayOfWeekValuesList"
      [clearable]="false"
      [searchable]="false"
      (change)="dayOfWeekValueChange($event)"
      (keyup.esc)="
        $event.stopImmediatePropagation(); fractionDayOfWeekValueSelect.blur()
      "
      (keyup.enter)="
        $event.stopImmediatePropagation(); fractionDayOfWeekValueSelect.blur()
      "
      [disabled]="isDisabled === true"
      [(ngModel)]="fraction.dayOfWeekValue"
      appendTo="body"
      bindLabel="label"
      bindValue="value"
    >
      <ng-template ng-label-tmp let-item="item">
        <div class="ml-1 truncate">{{ item.label }}</div>
      </ng-template>

      <ng-template ng-option-tmp let-item="item">
        <div class="ml-1 truncate">{{ item.label }}</div>
      </ng-template>
    </ng-select>
  </div>
</div>
